<div class="text">
    <h4>{{ label }}</h4>

    <h1 class="total">{{ total }}</h1>

    <!-- <span>
        <mat-icon color="primary">trending_up</mat-icon>
    </span> -->
</div>
<div class="widget">
    <!-- <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions"
        style="width: 100%; height: 60px; display: block;">
    </highcharts-chart> -->
</div>
